<app-breadcrumbs [breadcrumbs]="breadcrumbs"></app-breadcrumbs>

<div class="row">
  <div class="col-md-12 mx-auto">
    <h3>Configuracion de servicios por sucursal</h3>
  </div>
  <hr />

  <div class="d-grip gap-1 d-md-flex justify-content-md-end mb-5">
    <a [routerLink]="['/offices/list']" class="btn btn-outline-success">
      <i class="bi bi-arrow-left-circle"></i>
      Regresar a lista de sucursales
    </a>
  </div>

  <div class="col-sm-12 col-md-12 col-lg-12 mx-auto">
    <div *ngIf="isDisplayed" class="alert alert-danger" role="alert">
      {{ generalMessage }}
    </div>
    <div *ngIf="isSaved" class="alert alert-success" role="alert">
      {{ generalMessage }}
    </div>

    <form
      [formGroup]="packageTypeForm"
      (ngSubmit)="createUpdateType()"
      novalidate
    >
      <div class="accordion" id="cities_accordion">
        <div class="accordion-item">
          <h2 class="accordion-header" id="cities-information">
            <button
              class="accordion-button color-header-collapse"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseOne"
              aria-expanded="true"
              aria-controls="collapseOne"
              disabled
            >
              <span class="color-text">
                Configuraci&oacute;n de paquetes por sucursales
              </span>
            </button>
          </h2>
          <div
            id="collapseOne"
            class="accordion-collapse collapse show"
            aria-labelledby="headingOne"
            data-bs-parent="#accordionExample"
          >
            <input type="hidden" name="officeId" id="officeId" />
            <div class="accordion-body">
              <div class="row">
                <div class="form-check">
                  <input
                    type="checkbox"
                    class="form-check-input"
                    (change)="setValue($event, 1)"
                    id="depilacion"
                    [checked]="checkedDepilacion"
                    [disabled]="false"
                  />
                  <label for="depilacion" class="form-check-label">
                    Depilaci&oacute;n
                  </label>
                </div>
              </div>
              <div class="row">
                <div class="form-check">
                  <input
                    type="checkbox"
                    class="form-check-input"
                    (change)="setValue($event, 2)"
                    id="hidrafacial"
                    [checked]="checkedHidra"
                    [disabled]="false"
                  />
                  <label for="hidrafacial" class="form-check-label">
                    Hidrafacial
                  </label>
                </div>
              </div>
              <div class="row">
                <div class="form-check">
                  <input
                    type="checkbox"
                    class="form-check-input"
                    (change)="setValue($event, 3)"
                    id="radiofrecuencia"
                    [checked]="checkedRadio"
                    [disabled]="false"
                  />
                  <label for="radiofrecuencia" class="form-check-label">
                    Radiofrecuencia
                  </label>
                </div>
              </div>
              <div class="row">
                <div class="form-check">
                  <input
                    type="checkbox"
                    class="form-check-input"
                    (change)="setValue($event, 4)"
                    id="eterna_juventud"
                    [checked]="checkedEterna"
                    [disabled]="false"
                  />
                  <label for="eterna_juventud" class="form-check-label">
                    Eterna Juventud
                  </label>
                </div>
              </div>
              <div class="row">
                <div class="form-check">
                  <input 
                    type="checkbox" 
                    class="form-check-input"
                    (change)="setValue($event, 5)"
                    id="maderoterapia"
                    [checked]="checkedMadero"
                    [disabled]="false"
                  />
                  <label for="maderoterapia" class="form-check-label">
                    Maderoterapia / Metaloterapia
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="mb-3 mt-2 d-grip gap-2 d-md-flex justify-content-md-end">
        <button type="submit" class="btn btn-success">
          <i class="bi bi-plus-circle"></i>
          Actualizar
        </button>
      </div>
    </form>
  </div>
</div>
